import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export default function DocumentationSelect ({ open, onClose, onSelect }) {

    const handleClose = () => onClose();

    const [documentation, setDocumentation] = useState("");

    const handleChange = (e) => {
      onSelect(e.target.value);
    };

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogContent>
                <FormControl fullWidth sx={{ minHeight: 300 }}>
                  <InputLabel>
                    Select Documentation
                  </InputLabel>
                  <Select
                    value={documentation}
                    label="Select Documentation"
                    onChange={handleChange}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250, // adjust as needed
                        },
                      },
                    }}
                  >
                    <MenuItem value={"vitals"} sx={{ my: 1 }}>Vitals</MenuItem>
                    <MenuItem value={"inventory"} sx={{ my: 1 }}>Inventory</MenuItem>
                    <MenuItem value={"appointment"} sx={{ my: 1 }}>Appointment</MenuItem>
                    <MenuItem value={"prescription"} sx={{ my: 1 }}>Prescription</MenuItem>
                    <MenuItem value={"invoice"} sx={{ my: 1 }}>Invoice</MenuItem>
                    <MenuItem value={"waiver"} sx={{ my: 1 }}>Waiver</MenuItem>
                  </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}